import homeLayout from '@/views/core/layout'
import RouteView from '@/views/core/RouteView'

export const asyncRouterMap = [
         {
           path: '*',
           redirect: '/',
           hidden: true,
         },
         {
           path: '/',
           redirect: { path: '/dataScreen' },
           component: homeLayout,
           children: [
             {
               path: '/index',
               name: `index`,
               hidden: true,
               component: () => import('@/views/dataScreen/index'),
               meta: { title: '首页' },
             },
             {
               path: '/dataScreen',
               name: `index`,
               // hidden: true,
               component: () => import('@/views/dataScreen/index'),
               meta: {
                 title: '监控大屏',
                 icon: 'icon-jiankongdaping',
               },
             },
             {
               path: '/workStage',
               name: 'workStage',
               // hidden: true,
               component: () => import('@/views/workStage/index'),
               meta: {
                 title: '工作待办',
                 permission: ['work-bench'],
                 icon: 'icon-gongzuotai',
               },
             },
             {
               path: '/manage',
               name: 'manage',
               component: RouteView,
               meta: {
                 title: '用车管理',
                 permission: ['order'],
                 icon: 'icon-yongcheguanli',
               },
               children: ((pre) => [
                 {
                   path: '/manage/allApply',
                   name: `${pre}allApply`,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/allApply'),
                   meta: { title: '申请用车', permission: ['order-apply'] },
                 },
                 {
                   path: '/manage/approval',
                   name: `${pre}approval`,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/approval'),
                   meta: { title: '用车审批', permission: ['examine-list'] },
                 },
                 {
                   path: '/manage/list',
                   name: `${pre}list`,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/list'),
                   meta: { title: '用车列表', permission: ['order-list'] },
                 },
                 {
                   path: '/manage/dispatch',
                   name: `${pre}dispatch`,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/dispatch'),
                   meta: { title: '派车审批', permission: ['task-list'] },
                 },
                 {
                   path: '/manage/delivery',
                   name: `${pre}delivery`,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/delivery'),
                   meta: { title: '还车审核', permission: ['confirm-list'] },
                 },
                 {
                   path: '/manage/deliveryDetail',
                   name: `${pre}deliveryDetail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/delivery/detail'),
                   meta: { title: '还车单详情', permission: ['confirm-list'] },
                 },
                 {
                   path: '/manage/processSetting',
                   name: `${pre}processSetting`,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/processSetting'),
                   meta: { title: '流程设置' },
                   permission: ['system-flowroute'],
                 },
                 {
                   path: '/manage/signIn',
                   name: `${pre}signIn`,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/signIn'),
                   meta: { title: '签到列表', permission: ['logistics-task-list'] },
                 },
                 {
                   path: '/manage/apply',
                   name: `${pre}apply`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/apply/apply'),
                   meta: { title: '用车申请' },
                 },
                 {
                   path: '/manage/directlySend',
                   name: `${pre}directlySend`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/apply/directlySend'),
                   meta: { title: '用车申请' },
                 },
                 {
                   path: '/manage/register',
                   name: `${pre}register`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/apply/register'),
                   meta: { title: '用车登记' },
                 },
                 {
                   path: '/manage/handle',
                   name: `${pre}handle`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/dispatch/handle'),
                   meta: { title: '派车' },
                 },
                 {
                   path: '/manage/handleDetail',
                   name: `${pre}handleDetail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/dispatch/handleDetail'),
                   meta: { title: '派车详情' },
                 },
                 {
                   path: '/manage/detail',
                   name: `${pre}detail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/dispatch/detail'),
                   meta: { title: '用车详情' },
                 },
                 {
                   path: '/manage/oldDetail',
                   name: `${pre}detail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/dispatch/oldDetail'),
                   meta: { title: '用车详情' },
                 },
                 {
                   path: '/manage/playBackDetail',
                   name: `${pre}playBackDetail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "manage" */ '@/views/manage/signIn/playBackDetail'),
                   meta: { title: '签到详情' },
                 },
               ])('manage-'),
             },
             {
               path: '/private',
               name: 'private',

               component: RouteView,
               meta: {
                 title: '私车公用',
                 permission: ['private-car-order'],
                 icon: 'icon-sichegongyong',
               },
               children: ((pre) => [
                 // { path: '/calendar/driver', name: `${pre}driver`, component: () => import(  /* webpackChunkName: "calendarDriver" */ '@/views/calendar/driver'), meta: { title: '驾驶员日历', permission: ['calendar-driver'] } },
                 // { path: '/calendar/vehicle', name: `${pre}vehicle`, component: () => import(  /* webpackChunkName: "calendarVehicle" */ '@/views/calendar/vehicle'), meta: { title: '车辆日历', permission: ['calendar-car'] } },
                 {
                   path: '/private/privateCar',
                   name: `${pre}privateCar`,
                   component: () => import(/* webpackChunkName: "private" */ '@/views/archives/privateCar'),
                   meta: { title: '私车管理', permission: ['private-car-list'] },
                 },
                 {
                   path: '/private/apply',
                   name: `${pre}apply`,
                   component: () => import(/* webpackChunkName: "private" */ '@/views/archives/apply'),
                   meta: { title: '用车申请', permission: ['private-car-order-apply'] },
                 },
                 {
                   path: '/private/vehicleAudit',
                   name: `${pre}vehicleAudit`,
                   component: () => import(/* webpackChunkName: "private" */ '@/views/archives/vehicleAudit'),
                   meta: { title: '用车审批', permission: ['private-car-order-vehicleAudit'] },
                 },
                 {
                   path: '/private/delivery',
                   name: `${pre}delivery`,
                   component: () => import(/* webpackChunkName: "private" */ '@/views/archives/delivery'),
                   meta: { title: '还车审核', permission: ['private-car-order-delivery'] },
                 },
                 {
                   path: '/private/privateCarList',
                   name: `${pre}privateCarList`,
                   component: () => import(/* webpackChunkName: "private" */ '@/views/archives/privateCarList'),
                   meta: { title: '用车列表', permission: ['private-car-order-privateCarList'] },
                 },
               ])('private-'),
             },
             {
               path: '/service',
               name: 'service',
               component: RouteView,
               meta: {
                 title: '车务考勤',
                 permission: ['service'],
                 icon: 'icon-vhewukaoqin',
               },
               children: ((pre) => [
                 {
                   path: '/service/apply',
                   name: `${pre}apply`,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/apply'),
                   meta: { title: '申请', permission: ['service-leave-apply'] },
                 },
                 // {
                 //   path: '/service/schedule',
                 //   name: `${pre}schedule`,
                 //   component: () => import(/* webpackChunkName: "service" */ '@/views/service/schedule'),
                 //   meta: { title: '司机考勤', permission: ['service-leave-list'] },
                 // },
                 {
                   path: '/service/schedule/detail',
                   name: `${pre}detail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/schedule/detail'),
                   meta: { title: '考勤登记' },
                 },
                 {
                   path: '/service/repair',
                   name: `${pre}repair`,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/repair'),
                   meta: { title: '维修', permission: ['service-repair-list'] },
                 },
                 {
                   path: '/service/repairApply',
                   name: `${pre}repairApply`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/repair/apply'),
                   meta: { title: '新增维修' },
                 },
                 {
                   path: '/service/repairDetail',
                   name: `${pre}repairDetail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/repair/detail'),
                   meta: { title: '维修详情' },
                 },
                 {
                   path: '/service/maintain',
                   name: `${pre}maintain`,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/maintain'),
                   meta: { title: '保养', permission: ['service-maintain-list'] },
                 },
                 {
                   path: '/service/maintainApply',
                   name: `${pre}maintainApply`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/maintain/apply'),
                   meta: { title: '新增保养' },
                 },
                 {
                   path: '/service/maintainDetail',
                   name: `${pre}maintainDetail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/maintain/detail'),
                   meta: { title: '保养详情' },
                 },
                 {
                   path: '/service/mot',
                   name: `${pre}mot`,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/mot'),
                   meta: { title: '年检', permission: ['service-mot-list'] },
                 },
                 {
                   path: '/service/motApply',
                   name: `${pre}motApply`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/mot/apply'),
                   meta: { title: '年检登记' },
                 },
                 {
                   path: '/service/motDetail',
                   name: `${pre}motDetail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/mot/detail'),
                   meta: { title: '加油详情' },
                 },
                 {
                   path: '/service/fuel',
                   name: `${pre}fuel`,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/fuel'),
                   meta: { title: '加油', permission: ['service-fuel-list'] },
                 },
                 {
                   path: '/service/fuelDetail',
                   name: `${pre}fuelDetail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/fuel/detail'),
                   meta: { title: '加油详情' },
                 },
                 {
                   path: '/service/fuelApply',
                   name: `${pre}fuelApply`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/fuel/apply'),
                   meta: { title: '加油登记' },
                 },
                 {
                   path: '/service/insure',
                   name: `${pre}insure`,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/insure'),
                   meta: { title: '保险', permission: ['service-insure-list'] },
                 },
                 {
                   path: '/service/insureApply',
                   name: `${pre}insure`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/insure/apply'),
                   meta: { title: '保险登记', permission: ['service-insure-list'] },
                 },
                 {
                   path: '/service/insureDetail',
                   name: `${pre}insureDetail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/insure/detail'),
                   meta: { title: '保险详情' },
                 },
                 {
                   path: '/service/fee',
                   name: `${pre}fee`,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/fee'),
                   meta: { title: '其他', permission: ['service-fee-list'] },
                 },
                 {
                   path: '/service/feeApply',
                   name: `${pre}fee`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/fee/apply'),
                   meta: { title: '其他申请', permission: ['service-fee-list'] },
                 },
                 {
                   path: '/service/feeDetail',
                   name: `${pre}feeDetail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/fee/detail'),
                   meta: { title: '其他' },
                 },
                 {
                   path: '/service/accident',
                   name: `${pre}accident`,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/accident'),
                   meta: { title: '事故', permission: ['service-accident-list'] },
                 },
                 {
                   path: '/service/accidentDetail',
                   name: `${pre}accidentDetail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/accident/detail'),
                 },
                 {
                   path: '/service/accidentApply',
                   name: `${pre}accidentApply`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/accident/apply'),
                 },
                 {
                   path: '/service/violate',
                   name: `${pre}violate`,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/violate'),
                   meta: { title: '违章', permission: ['service-violate-list'] },
                 },
                 {
                   path: '/service/viloateApply',
                   name: `${pre}viloateApply`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/violate/apply'),
                 },
                 {
                   path: '/service/viloateDetail',
                   name: `${pre}viloateDetail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/violate/detail'),
                 },
                 {
                   path: '/service/vehicleService',
                   name: `${pre}vehicleService`,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/vehicleService'),
                   meta: { title: '车务核实', permission: ['car-service-check-page'] },
                 },
                 {
                   path: '/service/processSetting',
                   name: `${pre}processSetting`,
                   component: () => import(/* webpackChunkName: "service" */ '@/views/service/processSetting'),
                   meta: { title: '车务流程', permission: ['car-service-processSetting'] },
                 },
                 {
                   path: '/service/vehicleServiceDetail',
                   name: `${pre}vehicleServiceDetail`,
                   hidden: true,
                   component: () =>
                     import(/* webpackChunkName: "service" */ '@/views/service/vehicleService/components/detail'),
                   meta: { title: '车务详情' },
                 },
               ])('service-'),
             },
             {
               path: '/archives',
               name: 'archives',
               component: RouteView,
               meta: {
                 title: '档案管理',
                 permission: ['archives'],
                 icon: 'icon-danganguanli',
               },
               children: ((pre) => [
                 {
                   path: '/archives/personnelList',
                   name: `${pre}personnelList`,
                   component: () => import(/* webpackChunkName: "archives" */ '@/views/archives/personnelList/index'),
                   meta: { title: '人员列表', permission: ['archives-personnel'] },
                 },
                 {
                   path: '/archives/addPersonnel',
                   name: `${pre}addPersonnel`,
                   hidden: true,
                   component: () =>
                     import(/* webpackChunkName: "archives" */ '@/views/archives/addPersonnel/addPersonnel'),
                   meta: { title: '添加人员' },
                 },
                 {
                   path: '/archives/personDetail',
                   name: `${pre}carDetail`,
                   hidden: true,
                   component: () =>
                     import(/* webpackChunkName: "archives" */ '@/views/archives/personnelList/carDetail'),
                   meta: { title: '人员详情' },
                 },
                 {
                   path: '/archives/carManage',
                   name: `${pre}carManage`,
                   component: () => import(/* webpackChunkName: "archives" */ '@/views/archives/carManage/index'),
                   meta: { title: '车辆列表', permission: ['archives-car'] },
                 },
                 {
                   path: '/archives/addCars',
                   name: `${pre}addCars`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "archives" */ '@/views/archives/addCars/addCars'),
                   meta: { title: '添加车辆' },
                 },
                 {
                   path: '/archives/modifyCar',
                   name: `${pre}modifyCar`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "archives" */ '@/views/archives/addCars/addCars'),
                   meta: { title: '编辑车辆' },
                 },
                 {
                   path: '/archives/carDetail',
                   name: `${pre}carDetail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "archives" */ '@/views/archives/carManage/carDetail'),
                   meta: { title: '车辆详情' },
                 },
                 {
                   path: '/archives/driver',
                   name: `${pre}driver`,
                   component: () => import(/* webpackChunkName: "archives" */ '@/views/archives/driver/index'),
                   meta: { title: '司机列表', permission: ['archives-driver'] },
                 },
                 {
                   path: '/archives/addDriver',
                   name: `${pre}addDriver`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "archives" */ '@/views/archives/addDriver/addDriver'),
                   meta: { title: '添加司机' },
                 },
                 {
                   path: '/archives/modifyDriver',
                   name: `${pre}modifyDriver`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "archives" */ '@/views/archives/addDriver/addDriver'),
                   meta: { title: '编辑司机' },
                 },
                 {
                   path: '/archives/driverDetail',
                   name: `${pre}driverDetail`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "archives" */ '@/views/archives/driver/driverDetail'),
                   meta: { title: '司机详情' },
                 },
                 {
                   path: '/archives/hardware',
                   name: `${pre}hardware`,
                   component: () => import(/* webpackChunkName: "archives" */ '@/views/archives/hardware'),
                   meta: { title: '设备列表', permission: ['archives-hardware'] },
                 },
                 {
                   path: '/archives/addHardware',
                   name: `${pre}addHardware`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "archives" */ '@/views/archives/hardware/add'),
                   meta: { title: '新增设备' },
                 },
                 // { path: '/archives/oilCard', name: `${pre}oilCard`, component: () => import(  /* webpackChunkName: "archives" */ '@/views/archives/oilCard/index'), meta: { title: '油卡管理', /* permission: ['archives-car'] */ } },
                 // { path: '/archives/oilList', name: `${pre}oilList`, hidden: true, component: () => import(  /* webpackChunkName: "archives" */ '@/views/archives/oilList/index'), meta: { title: '油卡记录', /* permission: ['archives-car'] */ } },
                 // { path: '/archives/ETC', name: `${pre}ETC`, component: () => import(  /* webpackChunkName: "archives" */ '@/views/archives/ETC/index'), meta: { title: 'ETC管理', /* permission: ['archives-car'] */ } },
                 // { path: '/archives/ETCList', name: `${pre}ETCList`, hidden: true, component: () => import(  /* webpackChunkName: "archives" */ '@/views/archives/ETCList/index'), meta: { title: 'ETC记录', /* permission: ['archives-car'] */ } },
                 // {
                 //   path: '/archives/privateCar',
                 //   name: `${pre}privateCar`,
                 //   component: () => import(/* webpackChunkName: "archives" */ '@/views/archives/privateCar'),
                 //   meta: { title: '私家车管理', permission: ['private-car-list'] },
                 // },
               ])('archives-'),
             },

             {
               path: '/calendar',
               name: 'calendar',
               component: RouteView,
               meta: {
                 title: '日历管理',
                 permission: ['calendar'],
                 icon: 'icon-riliguanli',
               },
               children: ((pre) => [
                 {
                   path: '/calendar/driver',
                   name: `${pre}driver`,
                   component: () => import(/* webpackChunkName: "calendarDriver" */ '@/views/calendar/driver'),
                   meta: { title: '驾驶员日历', permission: ['calendar-driver'] },
                 },
                 {
                   path: '/calendar/vehicle',
                   name: `${pre}vehicle`,
                   component: () => import(/* webpackChunkName: "calendarVehicle" */ '@/views/calendar/vehicle'),
                   meta: { title: '车辆日历', permission: ['calendar-car'] },
                 },
               ])('calendar-'),
             },
             {
               path: '/report',
               name: 'report',
               component: RouteView,
               meta: {
                 title: '统计报表',
                 permission: ['report'],
                 icon: 'icon-tongjibaobiao',
               },
               children: ((pre) => [
                 {
                   path: '/report/carorder',
                   name: `${pre}carorder`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/carorder.vue'),
                   meta: { title: '用车报表', permission: ['report-carorder'] },
                 },
                 {
                   path: '/report/workorder',
                   name: `${pre}workorder`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/workorder.vue'),
                   meta: { title: '人员工时报表', permission: ['report-worktime'] },
                 },
                 {
                   path: '/report/workorderMC',
                   name: `${pre}workorderMC`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/workorderMC.vue'),
                   meta: { title: '机械工时报表', permission: ['report-worktime-mc'] },
                 },
                 {
                   path: '/report/carservice',
                   name: `${pre}carservice`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/carservice.vue'),
                   meta: { title: '车务报表', permission: ['report-carservice'] },
                 },
                 {
                   path: '/report/driver',
                   name: `${pre}driver`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/driver.vue'),
                   meta: { title: '司机报表', permission: ['report-driver'] },
                 },
                 {
                   path: '/report/leave',
                   name: `${pre}leave`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/leave.vue'),
                   meta: { title: '考勤报表', permission: ['report-leave'] },
                 },
                 {
                   path: '/report/mileage',
                   name: `${pre}mileage`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/mileage.vue'),
                   meta: { title: '里程报表', permission: ['report-mileage-list'] },
                 },
                 {
                   path: '/report/travel',
                   name: `${pre}travel`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/travel.vue'),
                   meta: { title: '行驶报表', permission: ['report-travel-list'] },
                 },
                 {
                   path: '/report/OBD',
                   name: `${pre}OBD`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/OBD.vue'),
                   meta: { title: 'OBD报表', permission: ['report-obd-travel-list'] },
                 },
                 {
                   path: '/report/parking',
                   name: `${pre}parking`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/parking.vue'),
                   meta: { title: '停车报表', permission: ['report-parking-list'] },
                 },
                 {
                   path: '/report/speeding',
                   name: `${pre}speeding`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/speeding.vue'),
                   meta: { title: '超速报表', permission: ['report-speeding-list'] },
                 },
                 {
                   path: '/report/idle',
                   name: `${pre}idle`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/idle.vue'),
                   meta: { title: '怠速报表', permission: ['report-idle-list'] },
                 },
                 {
                   path: '/report/fatigue',
                   name: `${pre}fatigue`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/fatigue.vue'),
                   meta: { title: '疲劳驾驶报表', permission: ['report-fatigue'] },
                 },
                 // { path: '/report/oilUse', name: `${pre}oilUse`, component: () => import(  /* webpackChunkName: "report" */ '@/views/report/oilUse.vue'), meta: { title: '行程油耗报表', permission: ['report-leave']  } },
                 // { path: '/report/oilMileage', name: `${pre}oilMileage`, component: () => import(  /* webpackChunkName: "report" */ '@/views/report/oilMileage.vue'), meta: { title: '油量里程报表', permission: ['report-leave']  } },
                 {
                   path: '/report/oil',
                   name: `${pre}oil`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/oil.vue'),
                   meta: { title: '油量报表', permission: ['report-oil'] },
                 },
                 {
                   path: '/report/temper',
                   name: `${pre}temper`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/temper.vue'),
                   meta: { title: '温度报表', permission: ['report-temperature'] },
                 },
                 {
                   path: '/report/humidity',
                   name: `${pre}humidity`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/humidity.vue'),
                   meta: { title: '湿度报表', permission: ['report-humidity'] },
                 },
                 {
                   path: '/report/illegal',
                   name: `${pre}illegal`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/illegal.vue'),
                   meta: { title: '违章报表', permission: ['report-violation-statistic'] },
                 },
                 {
                   path: '/report/magnetic',
                   name: `${pre}magnetic`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/magneticReport'),
                   meta: { title: '门磁报表', permission: ['report-iorecord-statistic'] },
                 },
                 {
                   path: '/report/sensor',
                   name: `${pre}sensor`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/sensor.vue'),
                   meta: { title: '传感器报表', permission: ['report-sensor'] },
                 },
                 {
                   path: '/report/consumption',
                   name: `${pre}consumption`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/consumption.vue'),
                   meta: { title: '消费记录', permission: ['report-sensor'] },
                 },
                 {
                   path: '/report/weighbridge',
                   name: `${pre}weighbridge`,
                   component: () => import(/* webpackChunkName: "report" */ '@/views/report/weighbridge.vue'),
                   meta: { title: '地磅报表', permission: ['report-weight'] },
                 },
               ])('report-'),
             },
             {
               path: '/activeSafety',
               name: 'activeSafety',
               component: RouteView,
               meta: {
                 title: '主动安全',
                 permission: ['adas'],
                 icon: 'icon-zhudonganquan',
               },
               children: ((pre) => [
                 {
                   path: '/activeSafety/riskEvidence',
                   name: `${pre}riskEvidence`,
                   component: () => import(/* webpackChunkName: "activeSafety" */ '@/views/activeSafety/riskEvidence'),
                   meta: { title: '风险证据库', permission: ['risk-evidence'] },
                 },
                 {
                   path: '/activeSafety/disposeReport',
                   name: `${pre}disposeReport`,
                   component: () => import(/* webpackChunkName: "activeSafety" */ '@/views/activeSafety/disposeReport'),
                   meta: { title: '主动安全处置', permission: ['disposeReport'] },
                 },
                 {
                   path: '/activeSafety/defineSetting',
                   name: `${pre}defineSetting`,
                   component: () => import(/* webpackChunkName: "activeSafety" */ '@/views/activeSafety/defineSetting'),
                   meta: { title: '参数设置', permission: ['adas-setting'] },
                 },
                 {
                   path: '/activeSafety/alarmReport',
                   name: `${pre}alarmReport`,
                   component: () =>
                     import(/* webpackChunkName: "activeSafety" */ '@/views/activeSafety/alarmReport/index'),
                   meta: { title: '报警排行统计', permission: ['alarmRisk'] },
                 },
                 {
                   path: '/activeSafety/safeReport',
                   name: `${pre}safeReport`,
                   component: () =>
                     import(/* webpackChunkName: "activeSafety" */ '@/views/activeSafety/safeReport/index'),
                   meta: { title: '主动安全统计', permission: ['adas-report'] },
                 },
               ])('activeSafety-'),
             },
             {
               path: '/warningCenter',
               name: 'warningCenter',
               component: RouteView,
               meta: {
                 title: '预警中心',
                 permission: ['alarm-center'],
                 icon: 'icon-yujingzhongxin',
               },
               children: ((pre) => [
                 {
                   path: '/warningCenter/disposeReport',
                   name: `${pre}disposeReport`,
                   component: () =>
                     import(/* webpackChunkName: "warningCenter" */ '@/views/activeSafety/disposeReport'),
                   meta: { title: '主动安全预警', permission: ['adas-alarm'] },
                 },
                 {
                   path: '/gpsMonitor/alarm',
                   name: `${pre}alarm`,
                   component: () => import(/* webpackChunkName: "warningCenter" */ '@/views/gpsMonitor/alarm'),
                   meta: { title: '报警记录', permission: ['alarm'] },
                 },
               ])('warningCenter-'),
             },
            //  {
            //    path: '/cost',
            //    name: 'cost',
            //    component: RouteView,
            //    meta: {
            //      title: '费用管理',
            //      permission: ['cost-manage'],
            //      icon: 'iconfont icon-feiyongguanli',
            //    },
            //    children: ((pre) => [
            //      {
            //        path: '/cost/manage',
            //        name: `${pre}manage`,
            //        component: () => import(/* webpackChunkName: "cost" */ '@/views/cost/manage'),
            //        meta: { title: '续费管理', permission: ['cost'] },
            //      },
            //      {
            //        path: '/account/chargingDetail',
            //        name: `${pre}chargingDetail`,
            //        component: () => import(/* webpackChunkName: "cost" */ '@/views/setting/chargingDetail'),
            //        meta: { title: '计费中心', permission: ['billing-center'] },
            //      },
            //    ])('cost-'),
            //  },
             {
               path: '/setting',
               name: 'setting',
               component: RouteView,
               meta: {
                 title: '系统配置',
                 permission: ['system'],
                 icon: 'icon-xitongpeizhi',
               },
               children: ((pre) => [
                 // { path: '/setting/dictionary', name: `${pre}dictionary`, component: () => import(  /* webpackChunkName: "setting" */ '@/views/setting/dictionary'), meta: { title: '数据字典' } },
                 {
                   path: '/setting/org',
                   name: `${pre}org`,
                   component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/org'),
                   meta: { title: '组织用户', permission: ['system-org'] },
                 },
                 {
                   path: '/setting/addOrg',
                   name: `${pre}addOrg`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/org/add'),
                   meta: { title: '新增用户' },
                 },
                 {
                   path: '/setting/role',
                   name: `${pre}role`,
                   component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/role'),
                   meta: { title: '角色管理', permission: ['system-role'] },
                 },
                 {
                   path: '/setting/addRole',
                   name: `${pre}addRole`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/role/add'),
                   meta: { title: '新增角色' },
                 },
                 // {
                 //   path: '/setting/approval',
                 //   name: `${pre}approval`,
                 //   component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/approval'),
                 //   meta: { title: '审批设置', permission: ['system-flowroute'] },
                 // },
                 {
                   path: '/setting/personal',
                   name: `${pre}personal`,
                   component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/personal'),
                   meta: { title: '个性化设置', permission: ['personalized-set'] },
                 },
                 // { path: '/account/charging', name: `${pre}charging`, component: () => import(  /* webpackChunkName: "setting" */ '@/views/setting/charging'), meta: { title: '计费中心', permission: ['calendar-driver'] } },

                 {
                   path: '/account/rechargeList',
                   name: `${pre}rechargeList`,
                   component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/rechargeList'),
                   hidden: true,
                   meta: { title: '消费明细' },
                   permission: ['calendar-driver'],
                 },
                 {
                   path: '/account/chargingDetailList',
                   name: `${pre}rechargeList`,
                   component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/chargingDetailList'),
                   hidden: true,
                   meta: { title: '充值记录' },
                   permission: ['calendar-driver'],
                 },
                 {
                   path: '/cost/manage',
                   name: `${pre}manage`,
                   component: () => import(/* webpackChunkName: "cost" */ '@/views/cost/manage'),
                   meta: { title: '续费管理' },
                 },
                 {
                   path: '/account/chargingDetail',
                   name: `${pre}chargingDetail`,
                   component: () => import(/* webpackChunkName: "cost" */ '@/views/setting/chargingDetail'),
                   meta: { title: '计费中心', permission: ['billing-center'] },
                 },
                 {
                   path: '/setting/userLog',
                   name: `${pre}userLog`,
                   component: () => import(/* webpackChunkName: "cost" */ '@/views/setting/userLog'),
                   meta: { title: '用户日志', permission: ['system-user-log'] },
                 },
               ])('setting-'),
             },
             {
               path: '/gpsMonitor',
               name: 'gpsMonitor',
               component: RouteView,
               meta: {
                 title: '监控中心',
                 permission: ['location'],
                 icon: 'icon-jiankongzhongxin',
               },
               children: ((pre) => [
                 {
                   path: '/gpsMonitor/realtime',
                   name: `${pre}realtime`,
                   component: () => import(/* webpackChunkName: "gpsMonitor" */ '@/views/gpsMonitor/realtime'),
                   meta: { title: '实时监控', permission: ['location-center'] },
                 },
                 {
                   path: '/gpsMonitor/videoMonitor',
                   name: `${pre}videoMonitor`,
                   component: () => import(/* webpackChunkName: "videoMonitor" */ '@/views/gpsMonitor/videoMonitor'),
                   meta: { title: '视频监控', permission: ['avideo-live-broadcast'] },
                 },
                 {
                   path: '/gpsMonitor/multiMonitor',
                   name: `${pre}multiMonitor`,
                   component: () => import(/* webpackChunkName: "gpsMonitor" */ '@/views/gpsMonitor/multiMonitor'),
                   meta: { title: '多窗口监控', permission: ['location-center'] },
                 },
                 {
                   path: '/gpsMonitor/trackPlayback',
                   name: `${pre}trackPlayback`,
                   component: () => import(/* webpackChunkName: "trackPlayback" */ '@/views/gpsMonitor/trackPlayback'),
                   meta: { title: '轨迹回放', permission: ['replay'] },
                 },
                 {
                   path: '/gpsMonitor/videoPlayback',
                   name: `${pre}videoPlayback`,
                   component: () => import(/* webpackChunkName: "videoPlayback" */ '@/views/gpsMonitor/videoPlayback'),
                   meta: { title: '视频回放', permission: ['avideo-replay'] },
                 },
                 {
                   path: '/gpsMonitor/posmanage',
                   name: `${pre}posmanage`,
                   component: () => import(/* webpackChunkName: "gpsOther" */ '@/views/gpsMonitor/posmanage'),
                   meta: { title: '位置管理', permission: ['point-area'] },
                 },
                 // { path: '/gpsMonitor/alarm', name: `${pre}alarm`, component: () => import( /* webpackChunkName: "warningCenter" */ '@/views/gpsMonitor/alarm'), meta: { title: '报警记录', permission: ['alarm'] } },
                 {
                   path: '/gpsMonitor/alarmSetting',
                   name: `${pre}alarmSetting`,
                   component: () => import(/* webpackChunkName: "gpsOther" */ '@/views/gpsMonitor/alarmSetting'),
                   meta: { title: '报警设置', permission: ['alarm-set'] },
                 },
               ])('gpsMonitor-'),
             },
             {
              path: '/weighbridge',
              name: 'weighbridge',
              component: RouteView,
              meta: {
                title: '地磅管理',
                permission: ['weight'],
                icon: 'icon-dibang',
              },
              children: ((pre) => [
                {
                  path: '/weighbridge/task',
                  name: `${pre}task`,
                  component: () => import(/* webpackChunkName: "weighbridge" */ '@/views/weighbridge/task'),
                  meta: { title: '地磅任务', permission: ['weight-ticket'] },
                },
                {
                  path: '/weighbridge/project',
                  name: `${pre}project`,
                  component: () => import(/* webpackChunkName: "weighbridge" */ '@/views/weighbridge/project'),
                  meta: { title: '项目管理', permission: ['weight-project'] },
                }
              ])('weighbridge-'),
             },
             {
               path: '/notice',
               name: `notice`,
               hidden: true,
               component: () => import(/* webpackChunkName: "setting" */ '@/views/notice/index'),
               meta: {
                 title: '系统消息',
               },
             },
             {
               path: '/workOrder',
               name: 'workOrder',
               component: RouteView,
               meta: {
                 title: '工单管理',
                 permission: ['work_order'],
                 icon: 'icon-gongdanguanli',
               },
               children: ((pre) => [
                 {
                   path: '/workOrder/order',
                   name: `${pre}order`,
                   component: () => import(/* webpackChunkName: "workOrder" */ '@/views/workOrder/order'),
                   meta: { title: '工单列表', permission: ['work_order'] },
                 },
                 {
                   path: '/workOrder/create',
                   name: `${pre}create`,
                   hidden: true,
                   component: () => import(/* webpackChunkName: "workOrder" */ '@/views/workOrder/order/create'),
                   meta: { title: '新增工单' },
                 },
               ])('workOrder-'),
             },
           ],
         },
       ]

export const constantRouterMap = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/core/login'),
  },
  {
    path: '/h5View',
    name: 'h5View',
    component: () => import('../views/h5v/h5View.vue'),
  },
  // {
  //   path:'/dataScreen',
  //   mame:'dataScreen',
  //   component:()=>import('@/views/dataScreen/index')
  // }
]
